export enum DropzoneTableViewColumn {
  FILE_NAME = "FILE_NAME",
  FILE_SIZE = "FILE_SIZE",
  FILE_ACTIONS = "FILE_ACTIONS",
}
